import React, { Fragment, useState, useEffect } from "react";
import CustomLoader from "../customLoader/CustomLoader";
import MessageService from "../../services/MsgService";
import DeleteModal from "../deleteModal/DeleteModal";
import MessageTemplateService from "../../services/MessageTemplateService";
// Using custom icon pagination & counselor template styling
// import CustomPagination from '../pagination/Pagination';
import { useSelector } from "react-redux";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import "../counselor/counselorMessageTemplate/CounselorMessageTemplate.css";
import pageLeft from "../../assets/images/CounselorCurrent/Page/left.png";
import pageLeftHide from "../../assets/images/CounselorCurrent/Page/left-hide.png";
import pageRight from "../../assets/images/CounselorCurrent/Page/right.png";
import pageCenter from "../../assets/images/CounselorCurrent/Page/center.png";
// Recruiter Message Template specific assets
import templateIcon from "../../assets/images/recruiteMessageTemplate/Icon.png";
import saveIcon from "../../assets/images/recruiteMessageTemplate/save.png";
import deleteIcon from "../../assets/images/recruiteMessageTemplate/delete.png";
import checkIcon from "../../assets/images/recruiteMessageTemplate/check.png";
import unCheckIcon from "../../assets/images/recruiteMessageTemplate/unCheck.png";
import "./MessageTemplate.css";
const MessageTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [pageData, setPageData] = useState();
  const user = useSelector(state => state.UserReducer?.userObj);
  const [page, setPage] = useState(1);
  const [subjectValue, setSubjectValue] = useState("");
  const [languageSelectedFromList, setLanguageSelectedFromList] = useState("");
  const [editValue, setEditValue] = useState();
  const [bodyMessageValue, setBodyMessageValue] = useState("");
  const [languageSelect, setLanguageSelect] = useState("en");
  const [includeFeedBack, setIncludeFeedback] = useState(false);
  const [openDeleteModal, setOpendeleteModal] = useState(false);
  const [feedbackValue, setFeedBackValue] = useState();
  const [, setShowBodyTranslating] = useState(false);
  const [, setShowSubjectTranslating] = useState(false);
  const [, setBodyValueInSpanish] = useState();
  const [, setSubjectValueInSpanish] = useState();
  const [, setFeedBackValueInSpanish] = useState();
  // const [sectionSelect, setSectionSelect] = useState('select section');
  const [selectedTemplateIndex, setSelectedTemplateIndex] = useState(null);
  const [activeTab] = useState("global-template");
  const getPageData = () => {
    setLoading(true);
    const fetchPageData = user?.role === "recruiter" ? MessageService.getCannedMsgPage(user?.role, user?.college, page) : MessageService.getCannedMsgPage(user?.role, user?.school_id, page);
    fetchPageData.then(data => {
      setPageData(data.data);
      setLoading(false);
      setIncludeFeedback(false);
    }).catch(_error => {
      setLoading(false);
    });
  };
  const handleSelect = (item, language, index) => {
    setSelectedTemplateIndex(index);

    // Set feedback checkbox based on ackError
    setIncludeFeedback(item?.answers?.["1"]?.ackError || false);

    // Set feedback text based on language
    if (item?.answers?.["1"]?.ackError && item?.answers?.text) {
      if (language === "en") {
        setFeedBackValue(item.answers.text.en || "");
      } else {
        setFeedBackValue(item.answers.text.es || "");
      }
    } else {
      setFeedBackValue("");
    }
    if (language === "en") {
      setEditValue(item);
      setSubjectValue(item?.messages?.en?.subject);
      setBodyMessageValue(item?.messages?.en?.body);
      // setSectionSelect(item?.messages?.en?.section || 'select section');
      setLanguageSelect("en");
      setLanguageSelectedFromList("en");
    } else if (language === "es") {
      setEditValue(item);
      setSubjectValue(item?.messages?.es?.subject);
      setBodyMessageValue(item?.messages?.es?.body);
      // setSectionSelect(item?.messages?.es?.section || 'select section');
      setLanguageSelect("es");
      setLanguageSelectedFromList("es");
    }
  };
  const renderFeedbackInput = () => {
    if (!includeFeedBack) return null;
    return <div className="feedback-inputs">
        <input type="text" className="feedback-input" placeholder={languageSelect === "en" ? "Enter feedback in English" : "Enter feedback in Spanish"} onChange={e => setFeedBackValue(e.target.value)} value={feedbackValue} disabled={languageSelectedFromList === "es"} />
        
      </div>;
  };
  const handleLanguageSelect = e => {
    setLanguageSelect(e.target.value);
  };
  const handleInputChange = e => {
    const {
      name,
      value,
      checked
    } = e.target;
    switch (name) {
      case "Subject":
        setSubjectValue(value);
        break;
      case "Body-Message":
        setBodyMessageValue(value);
        break;
      case "IncludeFeedback":
        setIncludeFeedback(checked);
        break;
      // case "Section":
      //     setSectionSelect(value);
      //     break;
      default:
        break;
    }
  };
  const saveTemplateForCreatingNew = async () => {
    if (!(subjectValue && subjectValue.trim() && bodyMessageValue && bodyMessageValue.trim())) return;
    setShowSubjectTranslating(true);
    setShowBodyTranslating(true);
    try {
      const [subjectTranslation, bodyTranslation,, feedbackTranslation] = await Promise.all([MessageTemplateService.translateTemplate({
        text: subjectValue,
        to: "es"
      }), MessageTemplateService.translateTemplate({
        text: bodyMessageValue,
        to: "es"
      }),
      // MessageTemplateService.translateTemplate({
      //     text: sectionSelect,
      //     to: 'es'
      // }),
      includeFeedBack && feedbackValue ? MessageTemplateService.translateTemplate({
        text: feedbackValue,
        to: "es"
      }) : Promise.resolve(null)]);
      const body = {
        messages: {
          en: {
            body: bodyMessageValue,
            subject: subjectValue
            // section: sectionSelect
          },
          es: {
            body: bodyTranslation.data.tr,
            subject: subjectTranslation.data.tr
            // section: sectionTranslation.data.tr
          }
        },
        answers: {
          "1": {
            ack: 0,
            ackError: includeFeedBack
          },
          text: {
            en: feedbackValue || "",
            es: feedbackTranslation?.data?.tr || ""
          },
          textError: false
        },
        college: user && user.college,
        languages: ["en", "es"]
      };
      await MessageTemplateService.getCannedMessageForTemplateAfterCreatingNew(body);
      resetForm();
      getPageData();
    } catch (error) {} finally {
      setShowSubjectTranslating(false);
      setShowBodyTranslating(false);
    }
  };
  const saveTemplateForEdit = async () => {
    if (!(subjectValue && subjectValue.trim() && bodyMessageValue && bodyMessageValue.trim())) return;
    setShowSubjectTranslating(true);
    setShowBodyTranslating(true);
    try {
      const [subjectTranslation, bodyTranslation,, feedbackTranslation] = await Promise.all([MessageTemplateService.translateTemplate({
        text: subjectValue,
        to: "es"
      }), MessageTemplateService.translateTemplate({
        text: bodyMessageValue,
        to: "es"
      }),
      // MessageTemplateService.translateTemplate({
      //     text: sectionSelect,
      //     to: 'es'
      // }),
      includeFeedBack && feedbackValue ? MessageTemplateService.translateTemplate({
        text: feedbackValue,
        to: "es"
      }) : Promise.resolve(null)]);
      const body = {
        messages: {
          en: {
            body: bodyMessageValue,
            subject: subjectValue
            // section: sectionSelect
          },
          es: {
            body: bodyTranslation.data.tr,
            subject: subjectTranslation.data.tr
            // section: sectionTranslation.data.tr
          }
        },
        answers: {
          "1": {
            ack: 0,
            ackError: includeFeedBack
          },
          text: {
            en: feedbackValue || "",
            es: feedbackTranslation?.data?.tr || ""
          },
          textError: false
        },
        id: editValue?.id,
        college: user && user.college,
        languages: ["en", "es"]
      };
      await MessageTemplateService.getCannedMessageForTemplateAfterEditing(body);
      resetForm();
      getPageData();
    } catch (error) {} finally {
      setShowSubjectTranslating(false);
      setShowBodyTranslating(false);
    }
  };
  const resetForm = () => {
    setSubjectValue("");
    setBodyMessageValue("");
    // setSectionSelect('select section');
    setIncludeFeedback(false);
    setFeedBackValue("");
    setEditValue(null);
    setSelectedTemplateIndex(null);
    setLanguageSelectedFromList("");
  };
  const deleteTemplate = () => {
    setOpendeleteModal(true);
  };
  useEffect(() => {
    getPageData();
  }, [page]);
  const renderTemplateList = () => {
    return pageData?.result?.map((item, index) => {
      const isSelected = selectedTemplateIndex === index;
      return <div key={index} className={`template-item ${isSelected ? "selected" : ""}`} onClick={() => handleSelect(item, "en", index)}>
          
          <h3 className="template-subject" title={item?.messages?.en?.subject}>
            {item?.messages?.en?.subject}
          </h3>
          <p className="template-body">{item?.messages?.en?.body}</p>
          <div className="language-buttons">
            <button type="button" className={`lang-btn-circle ${isSelected && languageSelectedFromList === "en" ? "active" : ""}`} onClick={e => {
            e.stopPropagation();
            handleSelect(item, "en", index);
          }}>
              
              EN
            </button>
            <button type="button" className={`lang-btn-circle ${isSelected && languageSelectedFromList === "es" ? "active" : ""}`} onClick={e => {
            e.stopPropagation();
            handleSelect(item, "es", index);
          }}>
              
              ES
            </button>
          </div>
        </div>;
    });
  };
  const renderTemplateForm = () => <div>
      <div className="template-creation-header">
        <h2>CREATE NEW MESSAGE TEMPLATES</h2>
      </div>

      <div className="template-form-group">
        <label style={{
        fontWeight: "bold",
        display: "block",
        marginBottom: "8px"
      }}>
        
          Language Preference
        </label>
        <div className="select-with-icon" style={{
        marginBottom: "20px"
      }}>
          <select disabled={languageSelectedFromList === "es"} className="view-dropdown" onChange={handleLanguageSelect} value={languageSelect} style={{
          width: "100%"
        }}>
          
            <option value="" disabled>
              Language Preference
            </option>
            <option value="en">EN</option>
            <option value="es">ES</option>
          </select>
        </div>

        <label style={{
        fontWeight: "bold",
        display: "block",
        marginBottom: "8px"
      }}>
        
          Subject
        </label>
        <input name="Subject" className="subject-input" type="text" placeholder="Enter Subject" value={subjectValue} disabled={languageSelectedFromList === "es"} onChange={handleInputChange} />
      

        <label style={{
        fontWeight: "bold",
        display: "block",
        marginBottom: "8px"
      }}>
        
          Body Message
        </label>
        <textarea name="Body-Message" className="body-input" placeholder="Enter Body Message" value={bodyMessageValue} disabled={languageSelectedFromList === "es"} onChange={handleInputChange} rows="6" />
      

        <div className="feedback-section">
          <div className="feedback-checkbox custom-feedback-toggle" onClick={() => setIncludeFeedback(!includeFeedBack)}>
          
            <img src={includeFeedBack ? checkIcon : unCheckIcon} alt={includeFeedBack ? "checked" : "unchecked"} className="feedback-toggle-icon" />
          
            <span>Include feedback response</span>
          </div>
          {renderFeedbackInput()}
        </div>

        <div className="template-actions">
          <button onClick={editValue ? saveTemplateForEdit : saveTemplateForCreatingNew} className="save-template-button with-icon" disabled={!(subjectValue && subjectValue.trim() && bodyMessageValue && bodyMessageValue.trim())}>


          
            <img src={saveIcon} alt="save" className="btn-icon" />
            {editValue ? "Update Template" : "Save Template"}
          </button>
          <button onClick={deleteTemplate} className="delete-template-button with-icon" disabled={!editValue}>
          
            <img src={deleteIcon} alt="delete" className="btn-icon" />
            Delete Template
          </button>
        </div>
      </div>
    </div>;
  return <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          {loading ? <CustomLoader /> : <div className="message-template-page-wrapper">
              {activeTab === "global-template" && <>
                  <div className="recruiter-page-top-title">
                    <img src={templateIcon} alt="Message Templates" className="page-title-icon" />
                
                    <h1 className="page-title-text">Message Templates</h1>
                  </div>
                  <div className="recruiter-template-card no-inner-header">
                    <div className="template-grid-container no-right-bg">
                      <div className="template-list-container">
                        <div className="template-list-inner">
                          <div className="template-list-scroll">
                            {renderTemplateList()}
                          </div>
                        </div>
                      </div>
                      <div className="template-creation-flat">
                        <div className="template-mode-title">
                          {editValue ? "Update Message Template" : "Create New Message Template"}
                        </div>
                        {renderTemplateForm()}
                      </div>
                    </div>

                    {pageData && <div className="template-pagination-container">
                        <div className="custom-pagination">
                          <button type="button" aria-label="Previous" className={`pagination-btn ${page === 1 ? "disabled" : ""}`} onClick={() => page > 1 && setPage(page - 1)}>
                      
                            <img src={page === 1 ? pageLeftHide : pageLeft} alt="Prev" className="pagination-img" />
                      
                          </button>
                          <div className="pagination-center">
                            <img src={pageCenter} alt="Page" className="pagination-img" />
                      
                            <span className="pagination-number">{page}</span>
                          </div>
                          <button type="button" aria-label="Next" className={`pagination-btn ${page >= (pageData?.max || pageData?.page_count || 1) ? "disabled" : ""}`} onClick={() => page < (pageData?.max || pageData?.page_count || 1) && setPage(page + 1)}>

                      
                            <img src={pageRight} alt="Next" className="pagination-img" />
                      
                          </button>
                        </div>
                      </div>}
                
                  </div>
                </>}
            
            </div>}
          
          {openDeleteModal && <DeleteModal deleteValue={editValue} openDeleteModal={openDeleteModal} setOpenDeleteModal={setOpendeleteModal} setDeleteValue={setEditValue} getQueryPage={getPageData} setBodyMessageValue={setBodyMessageValue} setSubjectValue={setSubjectValue} setIncludeFeedback={setIncludeFeedback} setFeedBackValue={setFeedBackValue} setSubjectValueInSpanish={setSubjectValueInSpanish} setBodyValueInSpanish={setBodyValueInSpanish} setFeedBackValueInSpanish={setFeedBackValueInSpanish} from="message-template" />}

          
        </div>
      </div>
    </Fragment>;
};
export default MessageTemplate;